"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@athena-portal/core");
var styles_1 = require("@material-ui/core/styles");
var styles_2 = require("@material-ui/core/styles");
var Theme = /** @class */ (function (_super) {
    __extends(Theme, _super);
    function Theme(props) {
        var _this = _super.call(this, props) || this;
        _this.getTheme = _this.getTheme.bind(_this);
        return _this;
    }
    Theme.prototype.render = function () {
        return React.createElement(styles_1.MuiThemeProvider, { theme: this.getTheme() }, this.props.children);
    };
    Theme.prototype.getTheme = function () {
        return (0, styles_2.createMuiTheme)({
            typography: {},
            overrides: {
                MuiButton: {
                    containedPrimary: {
                        color: this.themeVars.white,
                        borderRadius: this.themeVars.borderRadius,
                    },
                    outlinedPrimary: {
                        color: this.themeVars[this.props.color],
                        borderRadius: this.themeVars.borderRadius,
                    }
                },
                MuiInput: {
                    disabled: {
                        color: this.themeVars.gray900,
                        borderBottomColor: this.themeVars.gray900
                    }
                },
                MuiFormLabel: {
                    root: {
                        color: this.themeVars.gray900
                    }
                }
            },
            palette: {
                primary: {
                    main: this.themeVars[this.props.color],
                }
            },
        });
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ThemeVars),
        __metadata("design:type", core_1.ThemeVars)
    ], Theme.prototype, "themeVars", void 0);
    return Theme;
}(React.Component));
exports.default = Theme;
//# sourceMappingURL=Theme.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/Theme.js
// module id = 130
// module chunks = 0